// Based on https://ghe.spotify.net/creator/mrkt-web/blob/master/services/frodor/src/features/Module/MiniCarouselNoHeroModule/index.tsx
import React from 'react';
import styled from 'styled-components';
import {
  spacer4,
  white,
  spacer8,
  spacer20,
  gray75,
  screenMdMin,
  screenMdMax,
  screenXsMin,
} from '@spotify-internal/encore-foundation/web';
import {
  ButtonIcon,
  IconChevronLeft,
  IconChevronRight,
} from '@spotify-internal/encore-creator-web';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

interface Props {
  carouselSlides: JSX.Element[];
  nextSlideText: string;
  previousSlideText: string;
}

export function MiniCarousel(props: Props) {
  const ref = React.useRef<AliceCarousel>(null);

  const handleClickOnPrevButton = () => {
    const { current } = ref;

    if (!current) {
      return;
    }

    const { slidePrev } = current;
    slidePrev();
  };

  const handleClickOnNextButton = () => {
    const { current } = ref;

    if (!current) {
      return;
    }

    const { slideNext } = current;
    slideNext();
  };

  return (
    <MiniCarouselContainer>
      <Arrow onClick={handleClickOnPrevButton} aria-label={props.previousSlideText}>
        <IconChevronLeft iconSize={32} iconColor={white} />
      </Arrow>
      <CarouselContainer>
        <AliceCarousel
          items={props.carouselSlides.map((carouselSlide, index) => (
            <span key={index}>{carouselSlide}</span>
          ))}
          autoPlayInterval={4000}
          autoPlayDirection="ltr"
          autoPlay
          fadeOutAnimation
          mouseTrackingEnabled
          buttonsDisabled
          ref={ref}
          playButtonEnabled={false}
          disableAutoPlayOnAction
          duration={1000}
        />
      </CarouselContainer>
      <Arrow onClick={handleClickOnNextButton} aria-label={props.nextSlideText}>
        <IconChevronRight iconSize={32} iconColor={white} />
      </Arrow>
    </MiniCarouselContainer>
  );
}

const MiniCarouselContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Arrow = styled(ButtonIcon)`
  padding: 0 ${spacer4};
  &:hover {
  }
`;

const CarouselContainer = styled.div`
  width: 375px;

  @media (min-width: ${screenMdMax}) {
    width: 475px;
  }

  @media (max-width: ${screenXsMin}) {
    width: 200px;
  }

  display: flex;
  justify-content: center;

  .alice-carousel__dots {
    margin: 0px;
    padding-top: ${spacer8};
    height: ${spacer20};
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .alice-carousel__dots-item {
    width: ${spacer8};
    height: ${spacer8};
    border-radius: 50%;
    border: none;
    background-color: ${gray75};
    margin-left: ${spacer4};
    margin-right: ${spacer4};
    padding: 0px;
  }
  .alice-carousel__dots-item:hover,
  .alice-carousel__dots-item.__active {
    background-color: ${white};
  }
`;
